export const frequentquestions = [
  {
    title: '¿Puedo conectar mi báscula a la computadora?',
    description: 'Sí, siempre y cuando tu báscula tenga la conexión para computadora'
  },
  {
    title: '¿Puedo llevar un control de inventarios?',
    description: 'Sí, Basys te ayuda a llevar un control de inventarios y al instante podrás saber cuántos kilos tienes de cada material.'
  },
  {
    title: '¿Me ayuda a saber mis gastos y ganancias?',
    description: 'Sí, lleva un control de todos los gastos generados por compras, gastos operativos, etc. y aparte te calcula las ganancias obtenidas.'
  },
  {
    title: '¿Es necesario tener internet para que funcione el sistema?',
    description: 'No, no es necesario, pero si es de mucha ayuda para algún soporte técnico que pueda requerir.'
  },
  {
    title: '¿Me lleva un control de los clientes y proveedores con el precio especial que se le maneja a cada uno?',
    description: 'Sí, Basys genera un estado de cuenta de cada cliente o proveedor sabiendo así que y cuanto se le ha comprado a crédito o de contado, se maneja hasta 5 listas de precios diferentes para cada producto y se asignan a cada cliente.'
  },
  {
    title: '¿Me permite dar ticket por cada compra que haga para darle al cliente y en mi cierre me aparece como compra?',
    description: 'Sí, emite un ticket por cada compra/venta, olvídate de usar la calculadora para saber el total a pagar, el ticket lo hace automáticamente, se genera un corte de caja donde vienen todas las compras, las ventas, gastos e ingresos.'
  },
  {
    title: '¿Cómo es el proceso para tener el sistema Basys lo antes posible?',
    description: 'Contáctanos vía WhatsApp y uno de nuestros agentes te ayudará en todo el proceso, desde elegir el pan que más te convenga, realizar tu pago, hacer la instalación y darte capacitación.'
  }
]
